/**
 * DQ Workbench status / cadence / trending palette.
 *
 * One home for the non-brand accent colours the DQ surfaces share, so the
 * cadence cards, activity pills and "getting noisy" trending cards speak the
 * same colour language instead of each re-declaring a hex. Brand tokens
 * (teal / red / darkCyan / grey) still come from `poolwerxColors`; the
 * coral->red severity heat ramp lives in `dqHeatRamp.ts`.
 */
import { poolwerxColors } from './colors'

/** Cadence-bucket left-border accents - encode review urgency. */
export const dqCadenceAccent = {
  backlog: '#A32D2D', // overdue - deep red
  due_today: '#BA7517', // amber
  this_week: poolwerxColors.teal,
  this_month: '#3B6D11', // on-track green
} as const

/** "How much has the team looked at this period" progress strip. */
export const dqReviewedSegment = '#5DCAA5'
export const dqNotLookedSegment = poolwerxColors.grey[300]

/** Blocked status pill - red family (distinct from the brand red CTA). */
export const dqBlockedPill = { bg: '#FAE1E1', fg: '#A32D2D' } as const

/** "Getting noisy" trending surfaces - warm coral family. */
export const dqTrendingWarm = { bg: '#FAECE7', border: '#F5C4B3' } as const
/** Accent for trending rate bars / +delta text / the "Open Trending" link. */
export const dqTrendingAccent = '#D2683F'
